import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram, Youtube, Linkedin } from 'lucide-react';
import { clinicInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-primary text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="text-2xl font-bold mb-3">Mind Motion</h3>
            <p className="text-sm text-gray-100 mb-4">
              Personalised physiotherapy. Evidence-led. Local to Bellandur.
            </p>
            <p className="text-xs text-gray-200">
              Pain → Recovery → Movement
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Treatment
                </Link>
              </li>
              <li>
                <Link to="/online-physiotherapy" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Online Consult
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-100 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/locations" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Locations
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Helpful Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* Location & Contact (NAP) */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-lg font-semibold mb-4">Contact & Location</h4>
            <div className="space-y-2 text-sm text-gray-100">
              <p className="font-bold text-white text-base">Mind Motion Physiotherapy & Rehab Centre</p>
              <p> 10/2a, Bellandur Main Road, near Bellandur Gate, Bellandur, Bangalore — 560103</p>
              <p>Opposite Vyapar | Near Radware / Odessa Technologies</p>
              <p className="pt-2">Phone: <a href={`tel:${clinicInfo.phone}`} className="hover:text-white transition-colors">{clinicInfo.phone}</a></p>
              <p>Mon-Sat: 9:00 AM - 8:30 PM, Sun: 10:30 AM - 2:00 PM</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-100 order-2 md:order-1">
            © {new Date().getFullYear()} Mind Motion Physiotherapy and Rehab Centre. All rights reserved.
          </p>
          <div className="flex items-center gap-6 order-1 md:order-2">
            <a href={clinicInfo.socials.instagram} target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-200 transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={clinicInfo.socials.youtube} target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-200 transition-colors" aria-label="YouTube">
              <Youtube className="w-5 h-5" />
            </a>
            <a href={clinicInfo.socials.linkedin} target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-200 transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
